import { render, staticRenderFns } from "./infoSummary.vue?vue&type=template&id=b69e96dc"
import script from "./infoSummary.vue?vue&type=script&lang=js"
export * from "./infoSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports